<template>
  <el-container >
    <!-- 头部区域 -->
    <el-header class="app-header">
      <div class="header-left">
        <div class="logo-wrapper">
          <img src="../assets/image/logo.png" alt="" class="logo-img">
        </div>
        <span class="system-title">华连生足部健康管理系统</span>
      </div>
      <div class="header-right">
        <span class="org-name">{{orgName}}</span>
        <span class="header-divider">·</span>
        <el-link type="primary" @click="goToUserInfo" class="user-name">{{userName}}</el-link>
        <el-button class="header-btn" icon="iconfont icon-jigou" @click="showDialog()" title="机构选择"></el-button>
        <el-badge :value="msgNum" class="msg-badge" :hidden="msgNum === 0">
          <el-button class="header-btn" icon="iconfont icon-lingdang-xianxing" @click="openPengPengMsg()" title="消息中心"></el-button>
        </el-badge>
        <el-button class="header-btn" icon="iconfont icon-tuichudenglu" @click="logout()" title="退出登录"></el-button>
      </div>
    </el-header>

    <el-dialog title="机构选择" :visible.sync="setRightDialogVisible" width="40%" class="org-dialog"
               ref="orgDialog" @open="initDialogDrag" @closed="resetDialogPosition">
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirm()">确定</el-button>
        <el-button @click="cancel()">取消</el-button>
      </span>
      <el-input
        placeholder="输入关键字进行过滤"
        size="small"
        v-model="filterText"
        prefix-icon="el-icon-search"
        clearable>
      </el-input>
      <el-tree
        :data="orgList"
        :props="treeProps"
        @node-click="handleNodeClick"
        :highlight-current="true"
        node-key="id"
        :filter-node-method="filterNode"
        ref="tree">
      </el-tree>
    </el-dialog>
    <el-container>
      <el-aside :width="isCollapse ? '64px' : '220px'" class="app-aside">
        <div class="toggle-button" @click="toggleCollapse()">
          <i class="el-icon-s-fold" v-if="!isCollapse"></i>
          <i class="el-icon-s-unfold" v-else></i>
          <span v-if="!isCollapse">收起菜单</span>
        </div>
        <!-- 菜单栏 -->
        <el-menu
          background-color="#ffffff"
          text-color="#333333"
          active-text-color="#1890ff"
          :unique-opened="true"
          :collapse="isCollapse"
          :collapse-transition="false"
          :router="true"
          :default-active="activePath"
        >
          <!-- 一级菜单 -->
          <el-submenu index="1" v-if="authorities.includes('home')">
            <!-- 一级菜单的模板区 -->
            <template slot="title">
              <!--  图标 -->
              <i class="iconfont icon-shouye"></i>
              <!--  文本 -->
              <span>首页</span>
            </template>
            <el-menu-item index="/works" @click="saveNavState('/works')"
                          v-if="authorities.includes('works')">
              <template slot="title">
              <!--  图标 -->
              <i class="el-icon-menu"></i>
              <!--  文本 -->
              <span>工作台</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/work/task"
                          v-if="authorities.includes('work.task')"
                          @click="saveNavState('/work/task')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>工作任务</span>
              </template>
            </el-menu-item>
          </el-submenu>

          <!-- 一级菜单 -->
          <el-submenu index="2" v-if="authorities.includes('sales')">
            <!-- 一级菜单的模板区 -->
            <template slot="title">
              <!--  图标 -->
              <i class="iconfont icon-pinpaixiaoshou"></i>
              <!--  文本 -->
              <span>销售管理</span>
            </template>
            <el-menu-item index="/orders" @click="saveNavState('/orders')"
                          v-if="authorities.includes('sales.order')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>消费单</span>
              </template>
            </el-menu-item>

            <el-menu-item index="/refund" @click="saveNavState('/refund')"
                          v-if="authorities.includes('sales.refund.order')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>退费单</span>
              </template>
            </el-menu-item>

            <el-menu-item index="/arrearageOrders"
                          v-if="authorities.includes('sales.arrearageOrders')"
                          @click="saveNavState('/arrearageOrders')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>欠款单</span>
              </template>
            </el-menu-item>

            <el-menu-item index="/old/orders" @click="saveNavState('/old/orders')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>历史散客消费单</span>
              </template>
            </el-menu-item>

            <el-menu-item index="/oldOrderRefund" @click="saveNavState('/oldOrderRefund')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>历史退费单</span>
              </template>
            </el-menu-item>
          </el-submenu>

          <!-- 一级菜单 -->
          <el-submenu index="3" v-if="authorities.includes('customer')">
            <!-- 一级菜单的模板区 -->
            <template slot="title">
              <!--  图标 -->
              <i class="iconfont icon-huiyuan"></i>
              <!--  文本 -->
              <span>会员中心</span>
            </template>
            <el-menu-item index="/customers" @click="saveNavState('/customers')"
                          v-if="authorities.includes('customer.customers')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>会员列表</span>
              </template>
            </el-menu-item>

            <el-menu-item v-show="false" index="/card" @click="saveNavState('/card')"
                          v-if="authorities.includes('card')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>会员档案</span>
              </template>
            </el-menu-item>

            <el-menu-item index="/recharges" @click="saveNavState('/recharges')"
                          v-if="authorities.includes('customer.recharges')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>充值列表</span>
              </template>
            </el-menu-item>

            <el-menu-item index="/returnPremium" @click="saveNavState('/returnPremium')"
                          v-if="authorities.includes('customer.returnpremium')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>会员退费</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/buy/cika/list" @click="saveNavState('/buy/cika/list')"
                          >
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>次卡列表</span>
              </template>
            </el-menu-item>

            <el-menu-item index="/analyse" @click="saveNavState('/analyse')"
                          v-if="authorities.includes('customer.analyse')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>会员分析</span>
              </template>
            </el-menu-item>

            <el-menu-item index="/hbq/customer" @click="saveNavState('/hbq/customer')"
                          v-if="authorities.includes('customer.old')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>合并前档案</span>
              </template>
            </el-menu-item>

            <el-menu-item index="/old/recharges" @click="saveNavState('/recharges')"
                          v-if="authorities.includes('customer.recharges')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>历史充值列表</span>
              </template>
            </el-menu-item>
          </el-submenu>

          <!-- 一级菜单 -->
          <el-submenu index="4" v-if="authorities.includes('storage')">
            <!-- 一级菜单的模板区 -->
            <template slot="title">
              <!--  图标 -->
              <i class="iconfont icon-cangkukucun"></i>
              <!--  文本 -->
              <span>库存管理</span>
            </template>
            <el-menu-item index="/outPurchase" @click="saveNavState('/outPurchase')"
                          v-if="authorities.includes('storage.outpurchase')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>外部采购</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/outStorage" @click="saveNavState('/outStorage')"
                          v-if="authorities.includes('storage.outstock')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>外部出库</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/outStorage/print" @click="saveNavState('/inPurchase/print')"
                          v-if="authorities.includes('storage.inpurchase.print')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>外部-打印</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/inPurchase/apply" @click="saveNavState('/inPurchase/apply')"
                          v-if="authorities.includes('storage.inpurchase.apply')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>内部采购-申请</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/inPurchase/approve" @click="saveNavState('/inPurchase/approve')"
                          v-if="authorities.includes('storage.inpurchase.approve')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>内部采购-审批</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/inPurchase/print" @click="saveNavState('/inPurchase/print')"
                          v-if="authorities.includes('storage.inpurchase.print')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>内部-打印</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/send" @click="saveNavState('/send')"
                          v-if="authorities.includes('storage.inpurchase.send')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>内部发放-发放</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/receive" @click="saveNavState('/receive')"
                          v-if="authorities.includes('storage.inpurchase.receive')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>内部发放-接收</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/stock" @click="saveNavState('/stock')"
                          v-if="authorities.includes('storage.stock')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>库存</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/checkStock" @click="saveNavState('/checkStock')"
                          v-if="authorities.includes('storage.checkstock')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>盘点记录</span>
              </template>
            </el-menu-item>
          </el-submenu>

          <!-- 一级菜单 -->
          <el-submenu index="5" v-if="authorities.includes('employee')">
            <!-- 一级菜单的模板区 -->
            <template slot="title">
              <!--  图标 -->
              <i class="iconfont icon-yuangongguanli"></i>
              <!--  文本 -->
              <span>员工管理</span>
            </template>
            <el-menu-item index="/employees" @click="saveNavState('/employees')"
                          v-if="authorities.includes('employee.employees')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>员工列表</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/user/card/list"
                          v-if="authorities.includes('employee.card')"
                          @click="saveNavState('/user/card/list')"
                          >
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>员工档案</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/user/perf/rule"
                          v-if="authorities.includes('employee.perf.rule')"
                          @click="saveNavState('/user/perf/rule')"
            >
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>智能绩效</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/user/perf/rule/list"
                          v-if="authorities.includes('employee.perf.rule.list')"
                          @click="saveNavState('/user/perf/rule/list')"
            >
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>绩效列表</span>
              </template>
            </el-menu-item>
          </el-submenu>

          <!-- 一级菜单 -->
          <el-submenu index="6" v-if="authorities.includes('ppmsg')">
            <!-- 一级菜单的模板区 -->
            <template slot="title">
              <!--  图标 -->
              <i class="iconfont icon-lingdang-xianxing"></i>
              <!--  文本 v-if="authorities.includes('pengpengMsg')"  v-if="authorities.includes('pengpengMsg')"-->
              <span>消息中心</span>
            </template>
            <el-menu-item index="/pengpengMsg" @click="saveNavState('/pengpengMsg')"
                          v-if="authorities.includes('ppmsg.ppmsgs')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>消息列表</span>
              </template>
            </el-menu-item>
          </el-submenu>

          <!-- 一级菜单 -->
          <el-submenu index="7" v-if="authorities.includes('report')">
            <!-- 一级菜单的模板区 -->
            <template slot="title">
              <!--  图标 -->
              <i class="iconfont icon-baobiao"></i>
              <!--  文本 -->
              <span>报表管理</span>
            </template>
            <el-menu-item index="/performance" v-if="authorities.includes('report.yeji')"
                          @click="saveNavState('/performance')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>业绩报表</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/salary" @click="saveNavState('/salary')"
                          v-if="authorities.includes('report.jixiaogongzi')"
              >
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>绩效工资报表</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/salary/collect" @click="saveNavState('/salary/collect')"
                          v-if="authorities.includes('report.gongzihuizong')"
              >
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>工资汇总报表</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/profit" @click="saveNavState('/profit')"
                          v-if="authorities.includes('report.fenhonglirun')"
            >
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>分红利润报表</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/report/hy/cz"
                          @click="saveNavState('/report/hy/cz')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>会员储值表</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/shop/cb"
                          v-if="authorities.includes('report.shop.cb')"
                          @click="saveNavState('/shop/cb')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>门店成本占比表</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/my/yield"
                          v-if="authorities.includes('report.my.yield')"
                          @click="saveNavState('/my/yield')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>股东分红表</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/report/user/perf/rule"
                          v-if="authorities.includes('report.perf.rule')"
                          @click="saveNavState('/report/user/perf/rule')"
            >
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>智能绩效表</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/report/kdj"
                          @click="saveNavState('/report/kdj')"
            >
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>客单价表</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/report/ckjl"
                          @click="saveNavState('/report/ckjl')"
            >
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>出库记录表</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/report/product/sale/money"
                          @click="saveNavState('/report/product/sale/money')"
            >
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>商品销售情况表</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/report/product/sale/num"
                          @click="saveNavState('/report/product/sale/num')"
            >
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>商品销售进度表</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/reportSet"
                          v-if="authorities.includes('report.shezhi')"
                          @click="saveNavState('/reportSet')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>报表设置</span>
              </template>
            </el-menu-item>
          </el-submenu>

          <!-- 一级菜单 -->
          <el-submenu index="8" v-if="authorities.includes('finance')">
            <!-- 一级菜单的模板区 -->
            <template slot="title">
              <!--  图标 -->
              <i class="iconfont icon-pinpaixiaoshou"></i>
              <!--  文本 -->
              <span>财务管理</span>
            </template>
            <el-menu-item index="/submit/order"
                          v-if="authorities.includes('finance.yongyou')"
                          @click="saveNavState('/submitOrder')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>连通用友</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/shopExpend"
                          v-if="authorities.includes('finance.yingyeshouzhi')"
                          @click="saveNavState('/shopExpend')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>营业收支</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/expendType"
                          v-if="authorities.includes('finance.yingyeshouzhishezhi')"
                          @click="saveNavState('/expendType')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>营业收支设置</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/employee/subsidy"
                          v-if="authorities.includes('finance.yuangongbuzhu')"
                          @click="saveNavState('/employee/subsidy')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>员工补助</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/employee/subsidy/set"
                          v-if="authorities.includes('finance.yuangongbuzhushezhi')"
                          @click="saveNavState('/employee/subsidy/set')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>员工补助设置</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/employee/cost"
                          v-if="authorities.includes('finance.yuangongfeiyong')"
                          @click="saveNavState('/employee/cost')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>员工费用</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/employee/cost/set"
                          v-if="authorities.includes('finance.yuangongfeiyongshezhi')"
                          @click="saveNavState('/employee/cost/set')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>员工费用设置</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/shop/cost"
                          v-if="authorities.includes('finance.dianmianfeiyong')"
                          @click="saveNavState('/shop/cost')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>店面费用</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/shop/cost/set"
                          v-if="authorities.includes('finance.dianmianfeiyongshezhi')"
                          @click="saveNavState('/shop/cost/set')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>店面费用设置</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/alert/line/set"
                          v-if="authorities.includes('finance.alert.line')"
                          @click="saveNavState('/alert/line/set')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>警戒线设置</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/area/expend"
                          @click="saveNavState('/area/expend')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>公司明细账</span>
              </template>
            </el-menu-item>
          </el-submenu>
          <!-- 一级菜单 -->
          <el-submenu index="10" v-if="authorities.includes('discount.ticket')">
            <!-- 一级菜单的模板区 -->
            <template slot="title">
              <!--  图标 -->
              <i class="iconfont icon-quan"></i>
              <!--  文本 -->
              <span>优惠券管理</span>
            </template>
            <el-menu-item index="/discountTickets"
                          v-if="authorities.includes('discount.ticket.list')"
                          @click="saveNavState('/discountTickets')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>优惠券列表</span>
              </template>
            </el-menu-item>
          </el-submenu>
          <!-- 一级菜单 -->
          <el-submenu index="11" v-if="authorities.includes('kefu')">
            <!-- 一级菜单的模板区 -->
            <template slot="title">
              <!--  图标 -->
              <i class="iconfont icon-kefu"></i>
              <!--  文本 -->
              <span>客服管理</span>
            </template>
            <el-menu-item index="/contents"
                          v-if="authorities.includes('kefu.contents')"
                          @click="saveNavState('/contents')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>内容记录</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/reserves"
                          v-if="authorities.includes('kefu.reserves')"
                          @click="saveNavState('/reserves')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>预约列表</span>
              </template>
            </el-menu-item>
          </el-submenu>
          <!-- 一级菜单 -->
          <el-submenu index="12" v-if="authorities.includes('yie')">
            <!-- 一级菜单的模板区 -->
            <template slot="title">
              <!--  图标 -->
              <i class="iconfont icon-xitongshezhi"></i>
              <!--  文本 -->
              <span>股权管理</span>
            </template>
            <el-menu-item index="/my/yie/list" v-if="authorities.includes('yield.list')"
                          @click="saveNavState('/my/yie/list')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>股权列表</span>
              </template>
            </el-menu-item>
          </el-submenu>
          <!-- 一级菜单 -->
          <el-submenu index="20" v-if="authorities.includes('system')">
            <!-- 一级菜单的模板区 -->
            <template slot="title">
              <!--  图标 -->
              <i class="iconfont icon-xitongshezhi"></i>
              <!--  文本 -->
              <span>系统设置</span>
            </template>
            <el-menu-item index="/products" @click="saveNavState('/products')"
                          v-if="authorities.includes('system.product')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>产品设置</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/footServices" @click="saveNavState('/footServices')"
                          v-if="authorities.includes('system.service')"
            >
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>服务设置</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/ciCard" @click="saveNavState('/ciCard')"
                          v-if="authorities.includes('system.cicard')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>次卡管理</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/orgs"
                          v-if="authorities.includes('system.org')"
                          @click="saveNavState('/orgs')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>机构设置</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/outOrg"
                          v-if="authorities.includes('system.out.org')"
                          @click="saveNavState('/OutOrg')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>外部机构设置</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/payType"
                          v-if="authorities.includes('system.paytype')"
                          @click="saveNavState('/payType')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>支付方式设置</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/system/bxSp/set"
                          @click="saveNavState('/system/bxSp/set')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>报销审批设置</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/perf/set" v-if="authorities.includes('system.perf.set')"
                          @click="saveNavState('/perf/set')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>绩效设置</span>
              </template>
            </el-menu-item>
<!--            <el-menu-item index="/activity"-->
<!--                          v-if="authorities.includes('system.active')"-->
<!--                          @click="saveNavState('/activity')">-->
<!--              <template slot="title">-->
<!--                &lt;!&ndash;  图标 &ndash;&gt;-->
<!--                <i class="el-icon-menu"></i>-->
<!--                &lt;!&ndash;  文本 &ndash;&gt;-->
<!--                <span>活动设置</span>-->
<!--              </template>-->
<!--            </el-menu-item>-->
            <el-menu-item index="/roles"
                          v-if="authorities.includes('system.role')"
                          @click="saveNavState('/roles')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>角色设置</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/auths" v-if="authorities.includes('system.role.auths')"
                          @click="saveNavState('/auths')">
              <template slot="title">
                <!--  图标 -->
                <i class="el-icon-menu"></i>
                <!--  文本 -->
                <span>权限设置</span>
              </template>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-main class="app-main">
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>


</template>



<script>
export default {


  data(){
    return{
      //是否折叠
      isCollapse:false,
      activePath:'',
      filterText:'',
      setRightDialogVisible: false,
      orgList: [],
      treeProps: {
        label: 'orgName',
        children: 'children'
      },
      orgName:'',
      userName:'',
      orgData:'',
      orgId:'',
      authorities:'',
      msgNum:0,
      currentOrgId:''
    };

  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    $route(){
      this.activePath = this.$route.path;
    }
  },
  methods:{
    logout(){
      window.sessionStorage.clear();
      this.$router.push('/login')
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.orgName.indexOf(value) !== -1;
    },
    async handleNodeClick(data) {
      this.orgData = data;
      await this.confirm();
    },
    //点击按钮，菜单收缩与展开
    toggleCollapse(){
      this.isCollapse = ! this.isCollapse;
    },
    saveNavState(activePath){
      this.activePath = activePath;
    },
    async showDialog(){
      this.filterText = '';
      const {data:res} = await this.$http.get(`orgList/orgId/${this.orgId}`);
      this.orgList = [res.data];
      this.setRightDialogVisible = true;
    },
    async confirm(){
      if (this.orgData === null || this.orgData === ''){
        return this.$message.warning("请选择组织机构！")
      }
      window.sessionStorage.setItem('currentOrgId',this.orgData.id);
      window.sessionStorage.setItem('areaId',this.orgData.parentId);
      window.sessionStorage.setItem('orgName',this.orgData.orgName);
      window.sessionStorage.setItem('currentOrgPurchaseLevel',this.orgData.purchaseLevel);
      window.sessionStorage.setItem('orgLevel',this.orgData.level);
      window.sessionStorage.setItem('moLingRate',this.orgData.moLingRate);
      this.setRightDialogVisible = false;
      this.orgName = this.orgData.orgName;
      this.orgData = '';
      await this.$router.push('/home');
    },
    async cancel(){
      this.setRightDialogVisible = false;
    },
    async loadNotReadMsg(){
      if (this.currentOrgId === ''){
        this.currentOrgId = this.orgId;
      }
      const {data:res} = await this.$http.get(`pengpengMsg/orgId/${this.currentOrgId}` )
      this.msgNum = res.data.length;
    },
    loadMsg(){
      setTimeout(()=>{
        this.loadNotReadMsg();
      },2000)
    },
    openPengPengMsg(){
      this.$router.push("/pengpengMsg");
    },
    goToUserInfo(){
      this.$router.push('/userinfo');
    },
    // 初始化弹窗拖拽：在弹窗打开后给标题栏绑定 mousedown 拖动
    initDialogDrag(){
      this.$nextTick(() => {
        const dialogComp = this.$refs.orgDialog;
        if (!dialogComp || !dialogComp.$el) return;
        const dragDom = dialogComp.$el.querySelector('.el-dialog');
        const header = dialogComp.$el.querySelector('.el-dialog__header');
        if (!dragDom || !header) return;
        // 避免重复绑定
        if (header.dataset.dragBound) return;
        header.dataset.dragBound = '1';
        header.style.cursor = 'move';
        header.style.userSelect = 'none';
        header.onmousedown = (e) => {
          // 点击关闭按钮时不触发拖动
          if (e.target.closest('.el-dialog__headerbtn')) return;
          const rect = dragDom.getBoundingClientRect();
          const disX = e.clientX - rect.left;
          const disY = e.clientY - rect.top;
          const maxLeft = window.innerWidth - dragDom.offsetWidth;
          const maxTop = window.innerHeight - dragDom.offsetHeight;
          document.onmousemove = (ev) => {
            let left = ev.clientX - disX;
            let top = ev.clientY - disY;
            left = Math.max(0, Math.min(left, maxLeft));
            top = Math.max(0, Math.min(top, maxTop));
            dragDom.style.marginLeft = '0';
            dragDom.style.marginTop = '0';
            dragDom.style.left = left + 'px';
            dragDom.style.top = top + 'px';
          };
          document.onmouseup = () => {
            document.onmousemove = null;
            document.onmouseup = null;
          };
          e.preventDefault();
        };
      });
    },
    // 弹窗关闭后重置位置，避免下次打开时仍在拖动后的位置
    resetDialogPosition(){
      const dialogComp = this.$refs.orgDialog;
      if (!dialogComp || !dialogComp.$el) return;
      const dragDom = dialogComp.$el.querySelector('.el-dialog');
      if (!dragDom) return;
      dragDom.style.left = '';
      dragDom.style.top = '';
      dragDom.style.marginLeft = '';
      dragDom.style.marginTop = '';
    }
  },
  created() {
    this.orgName = window.sessionStorage.getItem('orgName');
    this.userName = window.sessionStorage.getItem('userName');
    this.orgId = window.sessionStorage.getItem('orgId');
    this.authorities = window.sessionStorage.getItem('authorities');
    this.currentOrgId = window.sessionStorage.getItem('currentOrgId');
    this.loadMsg();
  }
}
</script>

<style lang="less" scoped>
  .el-container{
    height: 100%;
  }
  /* 内层容器（含侧边栏+主内容）允许收缩，避免被内容撑高后被裁切 */
  .el-container .el-container{
    min-height: 0;
  }

  /* ============ 头部 ============ */
  .app-header{
    background: linear-gradient(135deg, #ffffff 0%, #f5f9ff 100%);
    width: 100%;
    height: 64px !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px 0 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    position: relative;
    z-index: 10;
    color: #1f2d3d;

    .header-left{
      display: flex;
      align-items: center;

      .logo-wrapper{
        width: 46px;
        height: 46px;
        border-radius: 12px;
        background: linear-gradient(135deg, #1890ff 0%, #36cfc9 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 4px 12px rgba(24, 144, 255, 0.25);
        margin-right: 14px;
        overflow: hidden;

        .logo-img{
          width: 34px;
          height: 34px;
          border-radius: 8px;
        }
      }

      .system-title{
        font-size: 20px;
        font-weight: 600;
        letter-spacing: 1px;
        color: #1f2d3d;
        background: linear-gradient(90deg, #1890ff, #36cfc9);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }

    .header-right{
      display: flex;
      align-items: center;
      gap: 10px;

      .org-name{
        font-size: 14px;
        color: #606266;
        font-weight: 500;
      }
      .header-divider{
        color: #c0c4cc;
        font-size: 14px;
      }
      .user-name{
        font-size: 15px;
        font-weight: 600;
        margin-right: 6px;
      }

      .header-btn{
        background-color: #f0f4f8;
        border: none;
        border-radius: 10px;
        width: 38px;
        height: 38px;
        padding: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: #5a6c7d;
        transition: all 0.25s ease;

        &:hover{
          background: linear-gradient(135deg, #1890ff 0%, #36cfc9 100%);
          color: #fff;
          transform: translateY(-1px);
          box-shadow: 0 4px 10px rgba(24, 144, 255, 0.3);
        }
        i{
          font-size: 18px;
        }
      }

      .msg-badge{
        /deep/ .el-badge__content{
          border: none;
        }
      }
    }
  }

  /* ============ 侧边栏 ============ */
  .app-aside{
    background-color: #ffffff;
    border-right: 1px solid #ebeef5;
    box-shadow: 1px 0 6px rgba(0, 0, 0, 0.04);
    transition: width 0.28s ease;
    overflow-x: hidden;
    overflow-y: auto;
    min-height: 0;

    .el-menu{
      border-right: 0;
      padding: 6px 10px;
    }
  }

  .toggle-button{
    background: linear-gradient(135deg, #f0f4f8 0%, #e8eef5 100%);
    font-size: 13px;
    line-height: 40px;
    color: #5a6c7d;
    text-align: center;
    cursor: pointer;
    margin: 10px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: all 0.25s ease;

    i{
      font-size: 18px;
    }

    &:hover{
      background: linear-gradient(135deg, #1890ff 0%, #36cfc9 100%);
      color: #fff;
      box-shadow: 0 4px 10px rgba(24, 144, 255, 0.3);
    }
  }

  /* ============ 菜单美化 ============ */
  /deep/ .el-menu{
    background-color: transparent !important;
  }
  /deep/ .el-submenu__title{
    border-radius: 8px !important;
    margin: 2px 0 !important;
    transition: all 0.2s ease !important;

    &:hover{
      background-color: #eaf4ff !important;
      color: #1890ff !important;
    }
    .iconfont{
      font-size: 18px;
      margin-right: 8px;
    }
  }
  /deep/ .el-menu-item{
    border-radius: 8px !important;
    margin: 2px 0 !important;
    height: 44px !important;
    line-height: 44px !important;
    transition: all 0.2s ease !important;

    &:hover{
      background-color: #eaf4ff !important;
      color: #1890ff !important;
    }
    &.is-active{
      background: linear-gradient(135deg, #1890ff 0%, #36cfc9 100%) !important;
      color: #fff !important;
      box-shadow: 0 3px 10px rgba(24, 144, 255, 0.3);
    }
    .el-icon-menu{
      font-size: 16px;
      margin-right: 8px;
    }
  }
  /deep/ .el-submenu .el-menu .el-menu-item{
    background-color: transparent !important;
    min-width: auto !important;
  }

  /* ============ 主内容区 ============ */
  .app-main{
    padding: 12px;
    background-color: #f5f7fa;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar{
      width: 0;
      display: none;
    }
  }

  /* ============ 弹窗 ============ */
  /deep/ .org-dialog{
    border-radius: 12px;
    overflow: hidden;

    .el-dialog{
      border-radius: 12px;
      overflow: hidden;
      box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
    }
    .el-dialog__header{
      background: linear-gradient(135deg, #1890ff 0%, #36cfc9 100%);
      padding: 16px 20px;
      .el-dialog__title{
        color: #fff;
        font-weight: 600;
        font-size: 16px;
      }
      .el-dialog__headerbtn{
        top: 16px;
        .el-dialog__close{
          color: #fff;
          font-size: 18px;
        }
      }
    }
    .el-dialog__body{
      padding: 16px 20px;
    }
    .el-tree{
      margin-top: 12px;
      background: transparent;
      max-height: 60vh;
      overflow-y: auto;
      overflow-x: hidden;
      padding-right: 4px;
      /deep/ .el-tree-node__content{
        height: 36px;
        border-radius: 6px;
        &:hover{
          background-color: #eaf4ff;
        }
      }
      /deep/ .is-current > .el-tree-node__content{
        background-color: #eaf4ff;
        color: #1890ff;
      }
    }
    /* 滚动条美化 */
    .el-tree::-webkit-scrollbar{
      width: 6px;
    }
    .el-tree::-webkit-scrollbar-thumb{
      background: #c0c4cc;
      border-radius: 3px;
    }
    .el-tree::-webkit-scrollbar-thumb:hover{
      background: #909399;
    }
    .el-tree::-webkit-scrollbar-track{
      background: transparent;
    }
  }

  .dialog-footer{
    display: flex;
    margin-top: 16px;
    justify-content: center;
    width: 100%;

    .el-button{
      min-width: 90px;
      border-radius: 8px;
      transition: all 0.25s ease;

      &:first-child{
        background: linear-gradient(135deg, #1890ff 0%, #36cfc9 100%);
        border: none;
        color: #fff;
        &:hover{
          box-shadow: 0 4px 10px rgba(24, 144, 255, 0.3);
          transform: translateY(-1px);
        }
      }
      &:last-child{
        &:hover{
          color: #1890ff;
          border-color: #1890ff;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue